import React, { useState } from 'react';
import './styles.less';
import { Grid } from '@mui/material';
import { useGlobal } from 'context';
import { Button } from 'components';
import { request } from 'utils/api';
import { PUBLIC_TOKEN } from 'utils/env';
import { Input } from 'components';
import { Select } from 'components';
import { withLayout } from 'helpers';
import { useFormVariant } from 'components/FeaturesContext';

function OutOfState({ history, nextRoute, hideForm }) {
  const { account, startInfo } = useGlobal();
  const formVariant = useFormVariant();

  const [email, setEmail] = useState(account.email || '');
  const [firstName, setFirstName] = useState(account.firstName || '');
  const [lastName, setLastName] = useState(account.lastName || '');
  const [gender, setGender] = useState(account.gender || '');

  // TODO: Actually use this if someone notices haha
  const fieldErrors = {};

  async function submit() {
    try {
      let practiceCode = sessionStorage.getItem('practiceCode');
      let falsyValues = [null, undefined, 'null', 'undefined'];
      await request({
        method: 'POST',
        path: '/v1/web/profile/create-lead',
        body: {
          dateOfBirth: startInfo.dateOfBirth,
          email,
          firstName,
          formVariant,
          landingPageVariant:
            'Nue life Out of State' +
            (!falsyValues.includes(practiceCode)
              ? ' [practice: ' + practiceCode + ']'
              : ''),
          gender,
          lastName,
          practiceCode,
          state: startInfo.state,
          utmCampaign: localStorage.utm_campaign,
          utmContent: localStorage.utm_content,
          utmMedium: localStorage.utm_medium,
          utmSource: localStorage.utm_source,
          utmTerm: localStorage.utm_term,
        },
        headers: { Authorization: `Basic ${PUBLIC_TOKEN}` },
      });
      window?.gtag('event', 'out_of_state_completed');
      history.push(nextRoute);
    } catch (e) {
      console.log(e);
    }
  }

  function renderForm() {
    return (
      <>
        <Grid item xs={12} md={3} justifyContent={'center'}>
          <Input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            label="First Name"
            error={fieldErrors.firstName}
          />
        </Grid>
        <Grid item xs={12} md={3} justifyContent={'center'}>
          <Input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            label="Last Name"
            error={fieldErrors.lastName}
          />
        </Grid>
        <Grid item xs={0} md={3} padding={'0 0 0 0'} />
        <Grid item xs={0} md={3} padding={'0 0 0 0'} />
        <Grid item xs={12} md={3} justifyContent={'center'}>
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="Email Address"
            error={fieldErrors.email}
          />
        </Grid>
        <Grid item xs={12} md={3} justifyContent={'center'}>
          <Select
            label="Gender"
            required
            name="gender"
            error={fieldErrors.gender}
            onChange={(e) => setGender(e.target.value)}
            options={[
              { value: '', text: 'Your gender' },
              { value: 'MALE', text: 'Male' },
              { value: 'FEMALE', text: 'Female' },
              { value: 'OTHER', text: 'Other' },
              { value: 'DECLINE_TO_SPECIFY', text: 'Decline to specify' },
            ]}
          />
        </Grid>
      </>
    );
  }

  return (
    <div className="blue_background">
      <div className="title_container">
        <Grid container spacing={2}>
          <Grid item xs={12} flexDirection={'column'} marginBottom={'1em'}>
            <h2 className="white label out_of_state_statement">
              Unfortunately we are not available in your area at this
              <br /> time. Would you like to be notified when we expand to
              <br /> your state?
            </h2>
          </Grid>
          <Grid item xs={0} md={3} />
          {!hideForm && renderForm()}
          <Grid item xs={0} md={3} />
          <Grid container justifyContent={'center'} marginTop={'1em'}>
            <Grid item xs={10} md={3}>
              <Button onClick={submit} secondary style={{ width: '100%' }}>
                {hideForm ? 'Yes, notify me' : 'Submit'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

OutOfState.title = 'Out Of State | Nue Life';

export default withLayout(OutOfState);